import { useState } from "react";
import { useEffect } from "react";
import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Image1 from "./img/webp/1Auvent textile architectural sur structure métallique – solution US SHADE pour protection solaire extérieure_imgupscale.webp"
import Image30 from "./img/webp/2Voiles d’ombrage architecturales en textile technique – solution US SHADE pour espaces publics.webp"
import Image3 from "./img/webp/3Systèmes de fixation inox pour architecture textile – câbles, tendeurs et accessoires US STRUCTURE.webp"
// import Image4 from "./img/webp/4Structures textiles monumentales en membrane tendue – architecture textile US SHADE & US STRUCTURE.webp"
import Image5 from "./img/webp/5Détail de fixation de toile architecturale textile sur structure aluminium – système US STRUCTURE UNIK SYSTEM.webp"
import Image6 from "./img/webp/6Voiles d’architecture textile tendue laissant passer la lumière naturelle – solution US SHADE pour espaces extérieurs.webp"
import Image7 from "./img/webp/7Ombrière textile architecturale sur esplanade moderne – protection solaire design US SHADE UNIK SYSTEM.webp"
import Image8 from "./img/webp/8Installation de structure métallique pour architecture textile tendue – chantier US STRUCTURE UNIK SYSTEM.webp"
import Image9 from "./img/webp/9Membranes textiles tendues sur structure acier – solution d’architecture textile moderne et durable.webp"
// import Image10 from "./img/webp/10Structure architecturale métallique et verrière design – architecture contemporaine à structure complexe.webp"
import Image11 from "./img/webp/11Détail technique de fixation membrane textile tendue sur structure métallique – architecture textile sur mesure.webp"
import Image12 from "./img/webp/12Toiture textile tendue circulaire sur structure métallique – solution d’architecture textile extérieure.webp"
import Image13 from "./img/webp/13Système de tension par câbles inox pour membrane textile – structure architecturale tendue haute performance.webp"
import Image14 from "./img/webp/14Pose manuelle de toile d’ombrage textile sur structure métallique – solution de protection solaire architecturale.webp"
import Image15 from "./img/webp/15Structure textile d’ombrage architecturale en membrane tendue – US SHADE UNIK SYSTEM.webp"
// import Image16 from "./img/webp/16Structure métallique et membrane textile haute performance – US STRUCTURE.webp"
// import Image17 from "./img/webp/17Architecture textile tendue pour protection solaire et design urbain.webp"
import Image18 from "./img/webp/18Installation de voile d’ombrage tendue avec câbles inox et mâts acier.webp"
import Image19 from "./img/webp/19Auvent textile architectural pour espace public et zones piétonnes.webp"
import Image20 from "./img/webp/20Toile d’ombrage design sur structure acier thermolaqué.webp"
import Image21 from "./img/webp/21Structure textile pour piscine avec couverture transparente et ossature métallique – protection climatique.webp"
// import Image22 from "./img/webp/22Ombrières textiles autoportantes en toile tendue – solution de protection solaire pour espaces publics.webp"
import Image23 from "./img/webp/23Architecture textile modulaire avec toiles tendues et structure métallique – design contemporain et ombrage extérieur.webp"
import Image24 from "./img/webp/24oiles tendues architecturales sur structure acier – protection solaire durable et esthétique.webp"
import Image25 from "./img/webp/25Voile d’ombrage textile bleue installée dans une école – protection solaire durable (1).webp"
import Image26 from "./img/webp/26Voile d’ombrage triangulaire en toile tendue pour terrasse résidentielle – protection solaire design.webp"
import Image27 from "./img/webp/27Voiles d’ombrage multiples sur espace public – solution US SHADE haute résistance UV.webp"
import Image28 from "./img/webp/28Voile d’ombrage textile vert installée dans une école – protection solaire durable (1).webp"
import Image29 from "./img/webp/29Installation de voile d’ombrage textile sur passage piéton extérieur.webp"
import Image2 from "./img/webp/30Structures textiles hexagonales sur poteaux métalliques – solution US SHADE pour zones piétonnes.webp"
import Image35 from "./img/webp/US-PARKING2.webp"
import Image34 from "./img/webp/image(1).webp"
import Image31 from "./img/webp/image(2).webp"
import Image32 from "./img/webp/image(3).webp"
import Image33 from "./img/webp/image.webp"







const images = [
  { id: 1, src: Image1,title: "Architecture Textile – Solutions d’Ombrage et de Protection" },
  { id: 2, src: Image2, title: "Solution Architecture Textil OFPPT Guelmim" },
  { id: 3, src: Image3,title: "Systèmes de fixation inox pour architecture textile – câbles, tendeurs"  },
  // { id: 4, src: Image4,title: "Structures textiles monumentales en membrane tendue"  },
  { id: 5, src: Image5,title: "Détail de fixation de toile architecturale textile sur structure aluminium"  },
  { id: 6, src: Image6, title: "Voiles d’architecture textile tendue laissant passer la lumière naturelle"  },
  { id: 7, src: Image7, title: "Ombrière textile architecturale sur esplanade moderne – protection solaire"  },
  { id: 8, src: Image8, title: "Installation de structure métallique pour architecture textile tendue"  },
  { id: 9, src: Image9, title: "Membranes textiles tendues sur structure acier – solution d’architecture textile moderne et durable"  },
  // { id: 10, src: Image10, title: "Structure architecturale métallique et verrière design – architecture contemporaine à structure complexe"  },
  { id: 11, src: Image11, title: "Détail technique de fixation membrane textile tendue sur structure métallique – architecture textile sur mesure"  },
  { id: 12, src: Image12, title: "Toiture textile tendue circulaire sur structure métallique – solution d’architecture textile extérieure"  },
  { id: 13, src: Image13, title: "Système de tension par câbles inox pour membrane textile – structure architecturale tendue haute performance"  },
  { id: 14, src: Image14, title: "Pose manuelle de toile d’ombrage textile sur structure métallique – solution de protection solaire architecturale"  },
  { id: 15, src: Image15, title: "Structure textile d’ombrage architecturale en membrane tendue"  },
  // { id: 16, src: Image16, title: "Toile d’ombrage design sur structure acier thermolaqué" },
  // { id: 17, src: Image17, title: "Structure textile pour piscine avec couverture transparente et ossature métallique" },
  { id: 18, src: Image18, title: "Ombrières textiles autoportantes en toile tendue – solution de protection solaire" },
  { id: 19, src: Image19, title: "Solution Architecture Textil - Canopée école Américaine" },
  { id: 20, src: Image20, title: "Solution Architecture Textile Marjane Laayoune" },
  { id: 21, src: Image21, title: "Solution Architecture Textile - Club Sportif O'Darb" },
  // { id: 22, src: Image22, title: "Structure textile tendue sur façade vitrée – architecture moderne et protection solaire" },
  { id: 23, src: Image23, title: "Solution Architecture Textil OFPPT Guelmim" },
  { id: 24, src: Image24, title: "Solution Architecture Textile - Club Sportif O'Darb" },
  { id: 25, src: Image25, title: "Structure textile pour espace public avec toiles tendues – architecture moderne et protection solaire" },
  { id: 26, src: Image26, title: "Toile d’ombrage textile sur structure métallique – solution de protection solaire extérieure" },
  { id: 27, src: Image27, title: "Solution Architecture Textile Marjane Laayoune" },
  { id: 28, src: Image28, title: "Toile d’ombrage textile sur structure métallique – solution de protection solaire" },
  { id: 29, src: Image29, title: "Solution Architecture Textil OFPPT Guelmim" },
  { id: 30, src: Image30, title: "Architecture textile tendue avec membrane en toile – design contemporain et ombrage extérieur" },
  { id: 31, src: Image31, title: "Système de tension par câbles inox pour membrane textile – structure architecturale tendue haute performance" },
  { id: 32, src: Image32, title: "Pose manuelle de toile d’ombrage textile sur structure métallique – solution de protection solaire architecturale" },
  { id: 33, src: Image33, title: "Structure textile d’ombrage architecturale en membrane tendue – US SHADE UNIK SYSTEM" },
  { id: 34, src: Image34, title: "Architecture textile modulaire avec toiles tendues et structure métallique – design contemporain et ombrage extérieur" },
  { id: 35, src: Image35, title: "Solution Architecture Textile - US PARKING" },

];
const Gallery = () => {
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1500, once: true });
  }, []);
  

  return (
    <>
      {/* ===== Title ===== */}
      <div className="container titre-gallry projects-header" id="titre-gallry">
        <h2 data-aos="fade-up" className="section-titles">
          Nos Réalisations – Projets & Installations Professionnelles
        </h2>
        <p data-aos="fade-up">
          Découvrez nos projets réalisés avec expertise et précision.
        </p>
      </div>

      {/* ===== Gallery ===== */}
      <div className="simple-gallery">
        {images.map((img) => (
          <div data-aos="zoom-in" key={img.id} className="gallery-item">
            <img src={img.src} alt={img.title} />

            {/* ✅ Zoom button */}
            <button
              className="zoom-icon"
              onClick={() => setActiveItem(img)}
              aria-label="Zoom image"
              loading="lazy"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </button>
          </div>
        ))}
      </div>

      {/* ===== Lightbox ===== */}
      {activeItem && (
        <div className="lightbox" onClick={() => setActiveItem(null)}>
          <div className="content" onClick={(e) => e.stopPropagation()}>
            <img src={activeItem.src} alt={activeItem.title} loading="lazy"/>
            
            {/* ✅ TITLE */}
            <div className="image-title">
              {activeItem.title}
            </div>

            <button
              className="close"
              onClick={() => setActiveItem(null)}
              aria-label="Close"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
